__turbopack_context__.v({
  "downloadButtonContainer": "_4HHthW_downloadButtonContainer",
  "primaryButton": "_4HHthW_primaryButton",
  "primaryButtonContent": "_4HHthW_primaryButtonContent",
  "primaryButtonWrapper": "_4HHthW_primaryButtonWrapper",
  "primaryIcon": "_4HHthW_primaryIcon",
  "secondaryLink": "_4HHthW_secondaryLink",
  "small": "_4HHthW_small",
  "smallWrapper": "_4HHthW_smallWrapper",
});
